// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductCondensedStyles } from "@stoneage/Overrides/Components/ProductCarouselProductCondensed";
import { css } from "styled-components";
import { color, ellipsis } from "@stoneage/XDL/Utilities";
import { fontConfig } from "@stoneage/XDL/constants";

productCarouselProductCondensedStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 64px 1fr 20px;
        gap: 8px;
        padding: 8px 4px;
        background-color: ${color("common.white")};
    `,
};

productCarouselProductCondensedStyles.productImageStyles = {
    image: {
        height: "64px",
        width: "64px",
    },
};

productCarouselProductCondensedStyles.productDetailsGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

productCarouselProductCondensedStyles.productDescriptionStyles = {
    productDetailLink: {
        color: "secondary",
        typographyProps: {
            ...fontConfig.xSmallSingleLine,
            weight: fontConfig.weight.medium,
        },
        css: css`
            margin-bottom: 0;
            width: auto;
            align-self: baseline;
            min-height: 28px;
        `,
    },
};

productCarouselProductCondensedStyles.productPartNumbersStyles = {
    erpNumberLabelText: {
        ...fontConfig.xSmallSingleLine,
        color: "text.main",
        css: css`
            white-space: nowrap;
        `,
    },
    erpNumberValueText: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
        color: "text.main",
        css: css`
            ${ellipsis(1)}
        `,
    },
};
